import { render, staticRenderFns } from "./Spaceplan.vue?vue&type=template&id=2a161f85&scoped=true&"
import script from "./Spaceplan.vue?vue&type=script&lang=js&"
export * from "./Spaceplan.vue?vue&type=script&lang=js&"
import style0 from "./Spaceplan.vue?vue&type=style&index=0&id=2a161f85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a161f85",
  null
  
)

export default component.exports